export default {
  overview: 'Overview',
  today_overview: 'Today\'s Overview',
  balance: 'Balance',
  in_transit: 'In Transit',
  abd_balance: 'Average Daily Balance',
  total_transaction: 'Total Transaction',
  transaction_count: 'Transaction Count',
  transaction_amount: 'Transaction Amount',
  transaction_fee: 'Transaction Fee',
  payin: 'Payin',
  payout: 'Payout',
  number: 'Transaction Count',
  amount: 'Amount',
  payin_number: 'Payin Count',
  payout_number: 'Payout Count',
  payin_amount: 'Payin Amount',
  payout_amount: 'Payout Amount',
  transaction_trends: 'Transaction Trends',
  all: 'All',
  fee: 'Fee',
  today: 'Today',
  week: 'Last 7 days',
  month: 'Last 30 days',
  commission: 'Commission',
  my_assets: 'My Assets',
  account_balance: 'Account Balance',
  balance_exchange_rate_tip: 'Calculated using real-time exchange rates. The balance shown on the withdrawal page shall prevail.',
  withdraw_now: 'Withdraw Now',
  collapse: 'Collapse',
  expand_more: 'Show More',
  reference_exchange_rate: 'Real-time Reference Exchange Rate',
  updated_at: 'Updated at',
  exchange_rate_disclaimer: 'This exchange rate is for reference only. The rate at the time of transaction shall prevail.',
  currency_assets: 'Currency Assets',
  available: 'Available',
  frozen: 'Frozen'
}
